const slotMachineContainer = document.querySelector('#slotMachineContainer');
const slotMachineHandle = document.querySelector('#slotMachineHandle');
const slotMachine = new SlotMachine(slotMachineContainer, {
    active: 1,
    delay: 1200,
    inViewport: false
});
var slotmMachineIsRunning = false;
var userStopSlotMachineFirstTime = false;
var slotMachineAnswer;
var slotMachineModalText;

/**
 * Hide or show the success message in modal.
 *
 * @param {boolean} isVisible
 */

function toggleSuccessMessage(isVisible) {
    if(isVisible)
    {
        $('#slot_machine_modal_form > div.form-group').hide();
        $('#slot_machine_modal_success_message').show();
    }
    else {
        $('#slot_machine_modal_form > div.form-group').show();
        $('#slot_machine_modal_success_message').hide();
    }
}

function chargeKlaviyoForm(extraPropertie) {
    const data = {
        hide_form_on_success: true,
        extra_properties: {}
    }
    data.extra_properties[`${extraPropertie}`] = slotMachineAnswer;
    KlaviyoSubscribe.attachToForms('#slot_machine_modal_form', {
        ...data,
        success: () => {
            toggleSuccessMessage(true);
            setTimeout(() => {
                $('#slot_machine_modal').modal('hide');
                toggleSuccessMessage(false);
            }, 1200);
        }
      });
}

/**
 * Shuffle the slot machine.
 *
 * @param {number} nbSpin number of spins that the machine will do;
 */

function shuffleMachine(nbSpin) {
    slotmMachineIsRunning = true;
    slotMachineHandle.classList.add('word-machine-scale');
    slotMachine.shuffle(nbSpin, slotMachineHandleButton);
}

window.addEventListener('scroll', function() {
    if(slotMachine.visible && !slotmMachineIsRunning && !userStopSlotMachineFirstTime)
        shuffleMachine(999999);
})

function showModal(extraPropertie) {
    slotmMachineIsRunning = false;
    if(!userStopSlotMachineFirstTime)
        userStopSlotMachineFirstTime = true;
    slotMachineAnswer = $.trim($(`#word-${slotMachine.visibleTile + 1}`).data('answer'));
    slotMachineModalText = $.trim($(`#word-${slotMachine.visibleTile + 1}`).data('modal'));
    $('#slot_machine_modal_body').html(slotMachineModalText);
    chargeKlaviyoForm(extraPropertie);
    slotMachineHandle.classList.remove('word-machine-scale');
    $('#slot_machine_modal').modal('show');
}

function slotMachineHandleButton(extraPropertie) {
    if(slotmMachineIsRunning)
      {
        if(slotMachine.running)
            slotMachine.stop(() => showModal(extraPropertie));
        else
            showModal(extraPropertie);
      }
    else {
        shuffleMachine(5);
    }
}